import clsx from 'clsx';
import React from 'react';
import type { SVGProps } from 'react';

import Button, { ButtonProps } from '../index';

type IconButtonProps = ButtonProps & {
  as: 'externalLink' | 'link' | 'button';
  icon: (props: SVGProps<SVGSVGElement>) => React.JSX.Element;
};

const IconButton = ({ className, children, icon: Icon, ...rest }: IconButtonProps) => {
  return (
    <Button
      className={clsx(
        className,
        'flex w-fit items-center justify-between gap-10 border-none bg-black px-16 py-8 font-suisse-intl-mono text-button-xs transition-colors hover:bg-grayscale-gray focus:bg-grayscale-gray focus:outline-none focus-visible:ring-4'
      )}
      {...rest}
    >
      {children}
      <Icon className="w-20 fill-current" />
    </Button>
  );
};

export default IconButton;
